export const templateStatusMessages = {
  active: { id: 'template-status.active', defaultMessage: 'Active' },
  inactive: { id: 'template-status.inactive', defaultMessage: 'Inactive' },
};

export const statusOptions = [
  { value: 'active', label: templateStatusMessages.active },
  { value: 'inactive', label: templateStatusMessages.inactive },
];
